class SmoothScroll {
  constructor(selector) {
    this.links = document.querySelectorAll(selector);
    this.addSmoothScroll();
  }

  addSmoothScroll() {
    this.links.forEach((link) => {
      link.addEventListener('click', this.handleClick.bind(link)); // Bind `this` to link element
    });
  }

  handleClick(e) {
    e.preventDefault();

    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const elementPosition = targetElement.offsetTop;
      const offsetPosition = elementPosition - 54;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      const url = new URL(window.location.href);
      url.hash = targetId;
      history.pushState({}, '', url);
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // Initialize smooth scroll for existing js-scroll-to class
  const smoothScroll = new SmoothScroll('.js-scroll-to');
});
